import React, { createContext, createElement, useContext, useMemo, useEffect } from 'react';
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

/* global Reflect, Promise */

var extendStatics = function (d, b) {
  extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
  };

  return extendStatics(d, b);
};

function __extends(d, b) {
  extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function () {
  __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;

  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];

  return r;
}

function pad(hash, len) {
  while (hash.length < len) {
    hash = '0' + hash;
  }

  return hash;
}

function fold(hash, text) {
  var i;
  var chr;
  var len;

  if (text.length === 0) {
    return hash;
  }

  for (i = 0, len = text.length; i < len; i++) {
    chr = text.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0;
  }

  return hash < 0 ? hash * -2 : hash;
}

function foldObject(hash, o, seen) {
  return Object.keys(o).sort().reduce(foldKey, hash);

  function foldKey(hash, key) {
    return foldValue(hash, o[key], key, seen);
  }
}

function foldValue(input, value, key, seen) {
  var hash = fold(fold(fold(input, key), toString(value)), typeof value);

  if (value === null) {
    return fold(hash, 'null');
  }

  if (value === undefined) {
    return fold(hash, 'undefined');
  }

  if (typeof value === 'object' || typeof value === 'function') {
    if (seen.indexOf(value) !== -1) {
      return fold(hash, '[Circular]' + key);
    }

    seen.push(value);
    var objHash = foldObject(hash, value, seen);

    if (!('valueOf' in value) || typeof value.valueOf !== 'function') {
      return objHash;
    }

    try {
      return fold(objHash, String(value.valueOf()));
    } catch (err) {
      return fold(objHash, '[valueOf exception]' + (err.stack || err.message));
    }
  }

  return fold(hash, value.toString());
}

function toString(o) {
  return Object.prototype.toString.call(o);
}

function sum(o) {
  return pad(foldValue(0, o, '', []).toString(16), 8);
}

var hashSum = sum;
var unitlessProperties = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
var propertyAliases = {
  bg: "backgroundColor",
  m: "margin",
  mt: "marginTop",
  mr: "marginRight",
  mb: "marginBottom",
  ml: "marginLeft",
  mx: "marginX",
  my: "marginY",
  p: "padding",
  pt: "paddingTop",
  pr: "paddingRight",
  pb: "paddingBottom",
  pl: "paddingLeft",
  px: "paddingX",
  py: "paddingY"
};
var multiplePropertyAliases = {
  marginX: ["marginLeft", "marginRight"],
  marginY: ["marginTop", "marginBottom"],
  paddingX: ["paddingLeft", "paddingRight"],
  paddingY: ["paddingTop", "paddingBottom"],
  size: ["width", "height"]
};
var propertyScales = {
  color: "colors",
  backgroundColor: "colors",
  borderColor: "colors",
  margin: "space",
  marginTop: "space",
  marginRight: "space",
  marginBottom: "space",
  marginLeft: "space",
  marginX: "space",
  marginY: "space",
  padding: "space",
  paddingTop: "space",
  paddingRight: "space",
  paddingBottom: "space",
  paddingLeft: "space",
  paddingX: "space",
  paddingY: "space",
  top: "space",
  right: "space",
  bottom: "space",
  left: "space",
  gridGap: "space",
  gridColumnGap: "space",
  gridRowGap: "space",
  gap: "space",
  columnGap: "space",
  rowGap: "space",
  fontFamily: "fonts",
  fontSize: "fontSizes",
  fontWeight: "fontWeights",
  lineHeight: "lineHeights",
  letterSpacing: "letterSpacings",
  border: "borders",
  borderTop: "borders",
  borderRight: "borders",
  borderBottom: "borders",
  borderLeft: "borders",
  borderWidth: "borderWidths",
  borderStyle: "borderStyles",
  borderRadius: "radii",
  borderTopRightRadius: "radii",
  borderTopLeftRadius: "radii",
  borderBottomRightRadius: "radii",
  borderBottomLeftRadius: "radii",
  borderTopWidth: "borderWidths",
  borderTopColor: "colors",
  borderTopStyle: "borderStyles",
  borderBottomWidth: "borderWidths",
  borderBottomColor: "colors",
  borderBottomStyle: "borderStyles",
  borderLeftWidth: "borderWidths",
  borderLeftColor: "colors",
  borderLeftStyle: "borderStyles",
  borderRightWidth: "borderWidths",
  borderRightColor: "colors",
  borderRightStyle: "borderStyles",
  outlineColor: "colors",
  boxShadow: "shadows",
  textShadow: "shadows",
  zIndex: "zIndices",
  width: "sizes",
  minWidth: "sizes",
  maxWidth: "sizes",
  height: "sizes",
  minHeight: "sizes",
  maxHeight: "sizes",
  flexBasis: "sizes",
  size: "sizes",
  // svg
  fill: "colors",
  stroke: "colors"
};
var negativeProperties = {
  margin: 1,
  marginTop: 1,
  marginRight: 1,
  marginBottom: 1,
  marginLeft: 1,
  marginX: 1,
  marginY: 1,
  top: 1,
  bottom: 1,
  left: 1,
  right: 1
};
var CSS_SYSTEM_CONFIG = {
  unitlessProperties: unitlessProperties,
  propertyAliases: propertyAliases,
  multiplePropertyAliases: multiplePropertyAliases,
  propertyScales: propertyScales,
  negativeProperties: negativeProperties
};

var get = function (obj, path, def) {
  var result = obj;
  var keys = typeof path === "string" ? path.split(".") : [path];

  for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
    var key = keys_1[_i];
    result = result ? result[key] : undefined;
  }

  return result === undefined ? def : result;
};

var positiveOrNegative = function (scale, value) {
  if (typeof value !== "number" || value >= 0) {
    return get(scale, value, value);
  }

  var absolute = Math.abs(value);
  var n = get(scale, absolute, absolute);

  if (typeof n === "string") {
    return "-" + n;
  }

  return n * -1;
};

var addUnitIfNeeded = function (name, value) {
  if (value == null || typeof value === "boolean" || value === "") {
    return "";
  }

  if (typeof value === "number" && value !== 0 && !(name in CSS_SYSTEM_CONFIG.unitlessProperties)) {
    return value + "px"; // Presumes implicit 'px' suffix for unitless numbers
  }

  return String(value).trim();
};

var camelCaseToSnakeCase = function (prop) {
  return prop.replace(/[A-Z]/g, function (match) {
    return "-" + match.toLowerCase();
  });
};

var responsive = function (systemObject, theme) {
  var next = {};
  var breakpoints = get(theme, "breakpoints");
  var mediaQueries = Object.entries(breakpoints).reduce(function (acc, _a, index) {
    var _b;

    var key = _a[0],
        value = _a[1];
    return __assign(__assign({}, acc), (_b = {}, _b[key] = "@media screen and (min-width: #" + index + "#" + value + ")", _b));
  }, {
    _: null
  });

  for (var key in systemObject) {
    var value = systemObject[key];
    var type = typeof value;

    if (value == null) {
      continue;
    }

    if (key.includes("&") || key.startsWith("@") || type === "string" || type === "number") {
      next[key] = value;
      continue;
    }

    var breakpointKeys = Object.keys(value);

    for (var _i = 0, breakpointKeys_1 = breakpointKeys; _i < breakpointKeys_1.length; _i++) {
      var breakpointKey = breakpointKeys_1[_i];
      var media = mediaQueries[breakpointKey];

      if (!media) {
        next[key] = value[breakpointKey];
        continue;
      }

      next[media] = next[media] || {};
      if (value[breakpointKey] == null) continue;
      next[media][key] = value[breakpointKey];
    }
  }

  return next;
};

var computeCssObject = function (systemObject, theme) {
  var result = {};
  var styles = responsive(systemObject, theme);

  for (var key in styles) {
    var val = styles[key];

    if (val && typeof val === "object") {
      result[key] = computeCssObject(val, theme);
      continue;
    }

    var prop = get(CSS_SYSTEM_CONFIG.propertyAliases, key, key);
    var scaleName = get(CSS_SYSTEM_CONFIG.propertyScales, prop);
    var scale = get(theme, scaleName, get(theme, prop, {}));
    var value = prop in CSS_SYSTEM_CONFIG.negativeProperties ? positiveOrNegative(scale, val) : get(scale, val, val);

    if (CSS_SYSTEM_CONFIG.multiplePropertyAliases[prop]) {
      var dirs = CSS_SYSTEM_CONFIG.multiplePropertyAliases[prop];

      for (var i = 0; i < dirs.length; i++) {
        result[dirs[i]] = value;
      }
    } else {
      result[prop] = value;
    }
  }

  return result;
};

var populateRulesObject = function (className, cssObject, acc) {
  Object.keys(cssObject).forEach(function (key) {
    var value = cssObject[key];

    if (typeof value === "string" || typeof value === "number") {
      if (!acc[className]) {
        acc[className] = "";
      }

      acc[className] += camelCaseToSnakeCase(key) + ":" + addUnitIfNeeded(key, value) + ";";
    } else if (typeof value === "object") {
      if (key.startsWith("@media") || key.startsWith("@supports")) {
        if (!acc[key]) {
          acc[key] = {};
        }

        populateRulesObject(className, value, acc[key]);
      } else {
        populateRulesObject(key.replace(/&/g, className), value, acc);
      }
    }
  });
};

var computeRulesObject = function (cssObject) {
  var rulesObject = {};
  populateRulesObject("&", cssObject, rulesObject);
  return rulesObject;
};

var EMPTY_ARRAY = [];
var GLOBAL_ID = "global";
var ID_ATTRIBUTE = "data-css-system-id";
var CREATED_IDS_ATTRIBUTE = "data-css-system-ids";
var CREATED_IDS_SEPARATOR = " ";
var isDev = typeof process === "object" && process.env && process.env.NODE_ENV === "development";

var ClientStyleSheet =
/** @class */
function () {
  function ClientStyleSheet(id) {
    var _this = this;

    this.createdIds = {};
    var element = document.querySelector("style[" + ID_ATTRIBUTE + "=\"" + id + "\"]");

    if (element === null) {
      element = document.createElement("style");
      element.setAttribute(ID_ATTRIBUTE, id);
      document.head.appendChild(element);
    } else {
      var createdIds = element.getAttribute(CREATED_IDS_ATTRIBUTE);

      if (createdIds !== null) {
        createdIds.split(CREATED_IDS_SEPARATOR).forEach(function (id) {
          return _this.createdIds[id] = true;
        });
      }
    }

    this.element = element;
  }

  ClientStyleSheet.prototype.insertRule = function (rule) {
    var sheet = this.element.sheet;
    sheet.insertRule(rule, sheet.cssRules.length);
  };

  ClientStyleSheet.prototype.remove = function () {
    this.element.remove();
  };

  return ClientStyleSheet;
}();

var DevClientStyleSheet =
/** @class */
function (_super) {
  __extends(DevClientStyleSheet, _super);

  function DevClientStyleSheet() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  DevClientStyleSheet.prototype.insertRule = function (rule) {
    this.element.textContent += rule + '\n';
  };

  return DevClientStyleSheet;
}(ClientStyleSheet);

var ClientStyleSheetManager =
/** @class */
function () {
  function ClientStyleSheetManager() {
    var _a;

    this.styleSheets = (_a = {}, _a[GLOBAL_ID] = new ClientStyleSheet(GLOBAL_ID), _a);
  }

  ClientStyleSheetManager.prototype.getGlobalStyleSheet = function () {
    return this.styleSheets[GLOBAL_ID];
  };

  ClientStyleSheetManager.prototype.createStyleSheet = function (id) {
    this.styleSheets[id] = new ClientStyleSheet(id);
    return this.styleSheets[id];
  };

  ClientStyleSheetManager.prototype.removeStyleSheet = function (id) {
    if (this.styleSheets[id]) {
      this.styleSheets[id].remove();
      delete this.styleSheets[id];
    }
  };

  return ClientStyleSheetManager;
}();

var DevClientStyleSheetManager =
/** @class */
function (_super) {
  __extends(DevClientStyleSheetManager, _super);

  function DevClientStyleSheetManager() {
    var _a;

    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.styleSheets = (_a = {}, _a[GLOBAL_ID] = new DevClientStyleSheet(GLOBAL_ID), _a);
    return _this;
  }

  DevClientStyleSheetManager.prototype.createStyleSheet = function (id) {
    this.styleSheets[id] = new DevClientStyleSheet(id);
    return this.styleSheets[id];
  };

  return DevClientStyleSheetManager;
}(ClientStyleSheetManager);

var ServerStyleSheet =
/** @class */
function () {
  function ServerStyleSheet(id) {
    this.rules = [];
    this.createdIds = {};
    this.id = id;
  }

  ServerStyleSheet.prototype.insertRule = function (rule) {
    this.rules.push(rule);
  };

  ServerStyleSheet.prototype.getStyleTag = function () {
    return "<style " + ID_ATTRIBUTE + "=\"" + this.id + "\" " + CREATED_IDS_ATTRIBUTE + "=\"" + Object.keys(this.createdIds).join(CREATED_IDS_SEPARATOR) + "\">" + this.rules.join("\n") + "</style>";
  };

  ServerStyleSheet.prototype.getStyleComponent = function () {
    var _a;

    return createElement("style", (_a = {}, _a[ID_ATTRIBUTE] = this.id, _a[CREATED_IDS_ATTRIBUTE] = Object.keys(this.createdIds).join(CREATED_IDS_SEPARATOR), _a.dangerouslySetInnerHTML = {
      __html: this.rules.join("\n")
    }, _a));
  };

  return ServerStyleSheet;
}();

var ServerStyleSheetManager =
/** @class */
function () {
  function ServerStyleSheetManager() {
    var _a;

    this.styleSheets = (_a = {}, _a[GLOBAL_ID] = new ServerStyleSheet(GLOBAL_ID), _a);
  }

  ServerStyleSheetManager.prototype.getGlobalStyleSheet = function () {
    return this.styleSheets[GLOBAL_ID];
  };

  ServerStyleSheetManager.prototype.createStyleSheet = function (id) {
    this.styleSheets[id] = new ServerStyleSheet(id);
    return this.styleSheets[id];
  };

  ServerStyleSheetManager.prototype.removeStyleSheet = function (id) {
    delete this.styleSheets[id];
  };

  ServerStyleSheetManager.prototype.getStyleTags = function () {
    return Object.values(this.styleSheets).map(function (styleSheet) {
      return styleSheet.getStyleTag();
    }).join("\n");
  };

  ServerStyleSheetManager.prototype.getStyleComponents = function () {
    return Object.values(this.styleSheets).map(function (styleSheet) {
      return styleSheet.getStyleComponent();
    });
  };

  return ServerStyleSheetManager;
}();

var isBrowser = typeof document !== "undefined";
var StyleSheetManagerContext = createContext(isBrowser ? isDev ? new DevClientStyleSheetManager() : new ClientStyleSheetManager() : new ServerStyleSheetManager());
var defaultTheme = {
  breakpoints: {
    s: "40em",
    m: "52em",
    l: "64em"
  },
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
};
var ThemeContext = createContext(defaultTheme);

var useCss = function (systemObject, deps) {
  if (deps === void 0) {
    deps = EMPTY_ARRAY;
  }

  var styleSheetManager = useContext(StyleSheetManagerContext);
  var theme = useContext(ThemeContext);
  var className = useMemo(function () {
    var cssObject = computeCssObject(systemObject, theme);
    var hash = hashSum(cssObject);
    var className = "style-" + hash;
    var styleSheet = styleSheetManager.getGlobalStyleSheet();

    if (!styleSheet.createdIds[className]) {
      var rulesObject = computeRulesObject(cssObject);
      var rulesKeys = Object.keys(rulesObject).sort(function (a, b) {
        return a < b ? -1 : a > b ? 1 : 0;
      });

      for (var _i = 0, rulesKeys_1 = rulesKeys; _i < rulesKeys_1.length; _i++) {
        var ruleKey = rulesKeys_1[_i];

        if (typeof rulesObject[ruleKey] === "string") {
          var selector = ruleKey.replace(/&/g, "." + className);
          var declaration = rulesObject[ruleKey];
          styleSheet.insertRule(selector + "{" + declaration + "}");
        } else {
          var identifier = ruleKey;
          var ruleObject = rulesObject[identifier];
          var ruleContent = "";

          for (var ruleObjectKey in ruleObject) {
            var selector = ruleObjectKey.replace(/&/g, "." + className);
            var declaration = ruleObject[ruleObjectKey];
            ruleContent += selector + "{" + declaration + "}";
          }

          styleSheet.insertRule(identifier.replace(/#\d#/, "") + "{" + ruleContent + "}");
        }
      }

      styleSheet.createdIds[className] = true;
    }

    return className;
  }, __spreadArrays([theme], deps));
  return className;
};

var useGlobalCss = function (systemObject, deps) {
  if (deps === void 0) {
    deps = EMPTY_ARRAY;
  }

  var styleSheetManager = useContext(StyleSheetManagerContext);
  var theme = useContext(ThemeContext);
  var id = useMemo(function () {
    var id = hashSum({
      systemObject: systemObject,
      theme: theme
    });
    var styleSheet = styleSheetManager.createStyleSheet(id);

    for (var globalSelector in systemObject) {
      var cssObject = computeCssObject(systemObject[globalSelector], theme);
      var rulesObject = computeRulesObject(cssObject);
      var rulesKeys = Object.keys(rulesObject).sort(function (a, b) {
        return a < b ? -1 : a > b ? 1 : 0;
      });

      for (var _i = 0, rulesKeys_1 = rulesKeys; _i < rulesKeys_1.length; _i++) {
        var ruleKey = rulesKeys_1[_i];

        if (typeof rulesObject[ruleKey] === "string") {
          var selector = ruleKey.replace(/&/g, globalSelector).replace(/#\d#/, "");
          var declaration = rulesObject[ruleKey];
          styleSheet.insertRule(selector + "{" + declaration + "}");
        } else {
          var identifier = ruleKey;
          var ruleObject = rulesObject[identifier];
          var ruleContent = "";

          for (var ruleObjectKey in ruleObject) {
            var selector = ruleObjectKey.replace(/&/g, globalSelector);
            var declaration = ruleObject[ruleObjectKey];
            ruleContent += selector + "{" + declaration + "}";
          }

          styleSheet.insertRule(identifier.replace(/#\d#/, "") + "{" + ruleContent + "}");
        }
      }
    }

    return id;
  }, __spreadArrays([theme], deps));
  useEffect(function () {
    return function () {
      return styleSheetManager.removeStyleSheet(id);
    };
  }, __spreadArrays([id, theme], deps));
};

var computeRules = function (systemObject, theme) {
  var result = "";

  for (var key in systemObject) {
    var val = systemObject[key];
    var prop = get(CSS_SYSTEM_CONFIG.propertyAliases, key, key);
    var scaleName = get(CSS_SYSTEM_CONFIG.propertyScales, prop);
    var scale = get(theme, scaleName, get(theme, prop, {}));
    var value = prop in CSS_SYSTEM_CONFIG.negativeProperties ? positiveOrNegative(scale, val) : get(scale, val, val);

    if (CSS_SYSTEM_CONFIG.multiplePropertyAliases[prop]) {
      var dirs = CSS_SYSTEM_CONFIG.multiplePropertyAliases[prop];

      for (var i = 0; i < dirs.length; i++) {
        result += camelCaseToSnakeCase(dirs[i]) + ":" + addUnitIfNeeded(prop, value) + ";";
      }
    } else {
      result += camelCaseToSnakeCase(prop) + ":" + addUnitIfNeeded(prop, value) + ";";
    }
  }

  return result;
};

var useKeyframes = function (keyframesObject, deps) {
  if (deps === void 0) {
    deps = EMPTY_ARRAY;
  }

  var styleSheetManager = useContext(StyleSheetManagerContext);
  var theme = useContext(ThemeContext);
  var id = useMemo(function () {
    var id = "keyframes-" + hashSum({
      keyframesObject: keyframesObject,
      theme: theme
    });
    var styleSheet = styleSheetManager.getGlobalStyleSheet();

    if (!styleSheet.createdIds[id]) {
      var frames_1 = "";

      for (var key in keyframesObject) {
        var systemObject = keyframesObject[key];
        var selector = isNaN(key) ? key : key + "%";
        var rules = computeRules(systemObject, theme);
        frames_1 += selector + "{" + rules + "}";
      }

      styleSheet.insertRule("@keyframes " + id + "{" + frames_1 + "}");
      styleSheet.createdIds[id] = true;
    }

    return id;
  }, __spreadArrays([theme], deps));
  return id;
};

var createMergeProps = function (_a) {
  var defaultCss = _a.css,
      defaultProps = __rest(_a, ["css"]);

  return function (_a) {
    var css = _a.css,
        props = __rest(_a, ["css"]);

    return __assign(__assign(__assign({}, defaultProps), {
      css: __assign(__assign({}, defaultCss), css)
    }), props);
  };
};

var createPrimitive = function (defaultComponent, defaultCssOrMergeProps) {
  var mergeProps = typeof defaultCssOrMergeProps === "function" ? defaultCssOrMergeProps : createMergeProps(defaultCssOrMergeProps);
  return React.forwardRef(function (props, ref) {
    var _a = mergeProps(props),
        _b = _a.as,
        Component = _b === void 0 ? defaultComponent : _b,
        css = _a.css,
        deps = _a.deps,
        className = _a.className,
        mergedProps = __rest(_a, ["as", "css", "deps", "className"]);

    var cssClassName = useCss(css, deps);
    var mergedClassName = className ? className + " " + cssClassName : cssClassName;
    return React.createElement(Component, __assign({
      ref: ref
    }, mergedProps, {
      className: mergedClassName
    }));
  });
};

var extendPrimitive = function (Primitive, defaultCssOrMergeProps) {
  var mergeProps = typeof defaultCssOrMergeProps === "function" ? defaultCssOrMergeProps : createMergeProps(defaultCssOrMergeProps);
  return React.forwardRef(function (props, ref) {
    var _a = mergeProps(props),
        css = _a.css,
        mergedProps = __rest(_a, ["css"]);

    return React.createElement(Primitive, __assign({
      ref: ref,
      css: css
    }, mergedProps));
  });
};

var useGap = function (_a) {
  var gap = _a.gap,
      otherCssProps = __rest(_a, ["gap"]);

  var flexDirection = otherCssProps.flexDirection;
  var theme = useContext(ThemeContext);
  var gapCssProps = useMemo(function () {
    var _a;

    if (gap && flexDirection) {
      if (typeof flexDirection === "string") {
        var isDirectionVertical = flexDirection === "column" || flexDirection === "column-reverse";
        return {
          "& > * + *": (_a = {}, _a[isDirectionVertical ? "mt" : "ml"] = gap, _a)
        };
      }

      var lastFlexDirection = void 0;
      var lastGap = void 0;
      var gaps = typeof gap === "object" ? gap : {
        _: gap
      };
      var flexDirections = flexDirection;
      var mergedBreakpointsSet = new Set(__spreadArrays(Object.keys(flexDirections), Object.keys(gaps)));
      var marginTops = {};
      var marginLefts = {};

      var themeBreakpoints = __spreadArrays(["_"], Object.keys(theme.breakpoints));

      for (var _i = 0, themeBreakpoints_1 = themeBreakpoints; _i < themeBreakpoints_1.length; _i++) {
        var themeBreakpoint = themeBreakpoints_1[_i];

        if (mergedBreakpointsSet.has(themeBreakpoint) === false) {
          continue;
        }

        var mergedBreakpoint = themeBreakpoint;
        var directionForCurrentBreakPoint = flexDirections[mergedBreakpoint] != null ? flexDirections[mergedBreakpoint] : lastFlexDirection;
        lastFlexDirection = directionForCurrentBreakPoint;
        var gapForCurrentBreakpoint = gaps[mergedBreakpoint] != null ? gaps[mergedBreakpoint] : lastGap;
        lastGap = gapForCurrentBreakpoint;
        var isDirectionVertical = directionForCurrentBreakPoint === "column" || directionForCurrentBreakPoint === "column-reverse";

        if (isDirectionVertical) {
          marginTops[mergedBreakpoint] = gapForCurrentBreakpoint;
          marginLefts[mergedBreakpoint] = 0;
        } else {
          marginLefts[mergedBreakpoint] = gapForCurrentBreakpoint;
          marginTops[mergedBreakpoint] = 0;
        }
      }

      return {
        "& > * + *": {
          mt: marginTops,
          ml: marginLefts
        }
      };
    }
  }, [gap, flexDirection, theme]);
  return gap ? __assign(__assign({}, otherCssProps), gapCssProps) : otherCssProps;
};

export { CSS_SYSTEM_CONFIG, ClientStyleSheetManager, ServerStyleSheetManager, StyleSheetManagerContext, ThemeContext, createPrimitive, extendPrimitive, useCss, useGap, useGlobalCss, useKeyframes };